import React from "react";
import "./style.scss";
import { formatTime } from "../../../constants/date";
import { capitalizeFullName } from "../../../constants/common";

interface ActivityCardProps {
  name: string;
  type: string;
  participation_level: string;
  description: string;
  tax_category: string;
  total_time_spent: any;
}

const ActivityCard: React.FC<ActivityCardProps> = ({
  name,
  type,
  participation_level,
  description,
  tax_category,
  total_time_spent,
}) => {
  return (
    <div className="box ">
      <div className="custom-card mx-auto">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <h5 className="mb-0 fw-bold">{name}</h5>
          </div>
          <div className="d-flex gap-2 mt-2 align-items-center flex-wrap">
            <span className="category-badge tag-sky-blue">
              {capitalizeFullName(type)}
            </span>
            <span
              className={
                participation_level.toLowerCase() == "active"
                  ? "category-badge"
                  : "category-badge tag-red"
              }
            >
              {capitalizeFullName(participation_level)}
            </span>
          </div>
          <div className="visit-text mt-3 mb-3 text-left">
            <p className="text-black text-left ">{description}</p>
          </div>
        </div>

        <div className="status-row d-flex justify-content-between align-items-center flex-wrap">
          <div className="sun">
            <span className="tag text-black text-left"> Tax Category: </span>
            <span
              className={
                participation_level.toLowerCase() == "active"
                  ? "tag tag-red mb-2"
                  : "tag tag-blue"
              }
            >
              {tax_category}{" "}
            </span>
          </div>
          {total_time_spent?.total_minutes > 0 && (
            <span className="time-badge">{formatTime(total_time_spent)}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityCard;
